import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

type users = {
  token: string;
  userId:string;
};

const { persistAtom } = recoilPersist({
  key: 'recoil-persist',
  storage: sessionStorage,
});

export const usersState = atom<users>({
  key: "usersState",
  default: {
    token: "",
    userId: ""
  },
  effects_UNSTABLE: [persistAtom],
});
